module.exports = __webpack_public_path__ + "img/text-and-image-default-left.6438c41c.svg";